import { AlertTriangle, UserPlus } from 'lucide-react';
import { useWorkshopProfile } from '@/hooks/useSettings';
import { useAuth } from '@/hooks/useAuth';

/**
 * Faixa do modo demonstração.
 *
 * Só existe um modo demonstração: a oficina-demo COMPARTILHADA que o visitante
 * anônimo abre pelo botão do login, sem cadastro. Não há mais como ligar
 * demonstração dentro da conta de um cliente — quando a flag aparece numa
 * oficina de verdade, é seed remanescente da época em que a opção existia, e a
 * saída é a limpeza em Configurações → Perfil da Oficina.
 */
export function DemoBanner() {
  const { profile } = useWorkshopProfile();
  const { isDemo, signOut } = useAuth();

  if (!profile?.isDemo) return null;

  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-200 bg-amber-50 px-4 py-2 dark:border-amber-900/60 dark:bg-amber-950/30">
      <div className="flex items-center gap-2 text-sm text-amber-800 dark:text-amber-200">
        <AlertTriangle size={16} className="shrink-0" />
        <span className="font-medium">MODO DEMONSTRAÇÃO</span>
        <span className="hidden sm:inline">— dados fictícios, nada é salvo</span>
      </div>
      {isDemo ? (
        // Visitante anônimo: CTA de conversão. Sair leva de volta ao /login
        // (tela com a proposta de valor + cadastro grátis).
        <button
          onClick={() => { void signOut(); }}
          className="flex items-center gap-1.5 rounded-md bg-primary px-3 py-1 text-xs font-semibold text-primary-foreground transition-opacity hover:opacity-90"
        >
          <UserPlus size={13} />
          Criar conta grátis
        </button>
      ) : (
        // Gestor de verdade numa oficina que carregou o seed: a saída é a
        // limpeza definitiva, não um reset que semearia tudo de novo.
        <span className="hidden text-xs text-amber-800 sm:inline dark:text-amber-200">
          Limpe em Configurações → Perfil da Oficina
        </span>
      )}
    </div>
  );
}
